<ion-content class="component-showcase">
  <div class="showcase-container">
    <h1 class="showcase-title">Tidy UI Components Showcase</h1>
    <p class="showcase-description">A comprehensive display of all customized Angular Material components from tidy-ui-components</p>

    <!-- Form Components Section -->
    <section class="component-section">
      <h2 class="section-title">Form Components</h2>

      <!-- Input Components -->
      <div class="component-group">
        <h3 class="group-title">Input Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Basic Input</h4>
            <tidy-input
              label="Text Input"
              placeholder="Enter text here"
              [icon]="'assets/svg/create.svg'"
              [form]="inputForm.get('textInput')"
              [submitted]="false" />
          </div>

          <div class="example-item">
            <h4>Email Input</h4>
            <tidy-input
              label="Email Address"
              placeholder="Enter email"
              type="email"
              [icon]="'assets/svg/mail.svg'"
              [form]="inputForm.get('emailInput')"
              [submitted]="false"
              [errorMessage]="getErrorMessage('emailInput')" />
          </div>

          <div class="example-item">
            <h4>Phone Input with Mask</h4>
            <tidy-input
              label="Phone Number"
              placeholder="(555) 123-4567"
              mask="phone"
              [icon]="'assets/svg/call.svg'"
              [form]="inputForm.get('phoneInput')"
              [submitted]="false" />
          </div>

          <div class="example-item">
            <h4>Currency Input</h4>
            <tidy-input
              label="Amount"
              placeholder="$0.00"
              mask="currencyMask"
              currencySymbol="$"
              [icon]="'assets/svg/cash.svg'"
              [form]="inputForm.get('currencyInput')"
              [submitted]="false" />
          </div>

          <div class="example-item">
            <h4>Password Input</h4>
            <tidy-input
              label="Password"
              placeholder="Enter password"
              type="password"
              [icon]="'assets/svg/lock-closed.svg'"
              [form]="inputForm.get('passwordInput')"
              [submitted]="false" />
          </div>

          <div class="example-item">
            <h4>Input with Icon</h4>
            <tidy-input
              label="Search"
              placeholder="Search..."
              [icon]="'assets/svg/search.svg'"
              [form]="inputForm.get('textInput')"
              [submitted]="false" />
          </div>
        </div>
      </div>

      <!-- Select Components -->
      <div class="component-group">
        <h3 class="group-title">Select Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Single Select</h4>
            <tidy-select
              label="Choose Option"
              [icon]="'assets/svg/list.svg'"
              [items]="selectOptions"
              [form]="selectForm.get('singleSelect')"
              [submitted]="false"
              (optionChange)="handleSelectChange($event)" />
          </div>

          <div class="example-item">
            <h4>Multi Select</h4>
            <tidy-select
              label="Choose Multiple Options"
              [icon]="'assets/svg/list.svg'"
              [items]="selectOptions"
              [multiple]="true"
              [form]="selectForm.get('multiSelect')"
              [submitted]="false"
              (optionChange)="handleSelectChange($event)" />
          </div>

          <div class="example-item">
            <h4>Select with Search</h4>
            <tidy-select
              label="Searchable Select"
              [icon]="'assets/svg/list.svg'"
              [items]="selectOptions"
              [form]="selectForm.get('singleSelect')"
              [submitted]="false"
              searchPlaceholder="Search options..."
              (optionChange)="handleSelectChange($event)" />
          </div>
        </div>
      </div>

      <!-- Autocomplete -->
      <div class="component-group">
        <h3 class="group-title">Autocomplete</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Autocomplete Input</h4>
            <tidy-auto-complete
              label="Fruit Selection"
              placeholder="Type to search fruits..."
              [icon]="'assets/svg/search.svg'"
              [items]="autocompleteOptions"
              [form]="inputForm.get('textInput')"
              [submitted]="false" />
          </div>
        </div>
      </div>

      <!-- Checkbox Components -->
      <div class="component-group">
        <h3 class="group-title">Checkbox Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Basic Checkbox</h4>
            <tidy-checkbox
              label="Accept Terms"
              [form]="checkboxForm.get('checkbox1')"
              [submitted]="false"
              (optionChange)="handleCheckboxChange($event)" />
          </div>

          <div class="example-item">
            <h4>Checkbox Button</h4>
            <tidy-checkbox-button
              text="Checkbox Button"
              [form]="checkboxForm.get('checkbox2')"
              [submitted]="false"
              (optionChange)="handleCheckboxChange($event)" />
          </div>
        </div>
      </div>

      <!-- Radio Button Components -->
      <div class="component-group">
        <h3 class="group-title">Radio Button Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Radio Button Group</h4>
            <tidy-radio-button
              label="Choose Option"
              [items]="selectOptions"
              [form]="radioForm.get('radioGroup')"
              [submitted]="false"
              (optionChange)="handleRadioChange($event)" />
          </div>
        </div>
      </div>

      <!-- Toggle Components -->
      <div class="component-group">
        <h3 class="group-title">Toggle Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Toggle Switch</h4>
            <tidy-toggle
              label="Enable Notifications"
              [form]="toggleForm.get('toggle1')"
              [submitted]="false"
              (optionChange)="handleToggleChange($event)" />
          </div>
        </div>
      </div>

      <!-- Date Picker Components -->
      <div class="component-group">
        <h3 class="group-title">Date Picker Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Date Picker</h4>
            <tidy-datepicker
              label="Select Date"
              [icon]="'assets/svg/calendar.svg'"
              [form]="dateForm.get('datePicker')"
              [submitted]="false"
              (optionChange)="handleDateChange($event)" />
          </div>

          <div class="example-item">
            <h4>Date Range Picker</h4>
            <tidy-daterange-picker
              label="Select Date Range"
              [icon]="'assets/svg/calendar.svg'"
              [form]="dateForm.get('dateRange')"
              [submitted]="false"
              (optionChange)="handleDateChange($event)" />
          </div>
        </div>
      </div>

      <!-- Textarea -->
      <div class="component-group">
        <h3 class="group-title">Textarea</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Message Textarea</h4>
            <tidy-textarea
              label="Message"
              placeholder="Enter your message here..."
              [icon]="'assets/svg/document-text.svg'"
              [form]="textareaForm.get('message')"
              [submitted]="false" />
          </div>
        </div>
      </div>

      <!-- File Upload -->
      <div class="component-group">
        <h3 class="group-title">File Upload</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>File Upload Component</h4>
            <tidy-file-upload
              label="Upload Files"
              (fileChange)="handleFileUpload($event)" />
          </div>
        </div>
      </div>
    </section>

    <!-- Button Components Section -->
    <section class="component-section">
      <h2 class="section-title">Button Components</h2>

      <div class="component-group">
        <h3 class="group-title">Button Variants</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Primary Button</h4>
            <tidy-button
              text="Click Me"
              [action]="handleButtonClick" />
          </div>

          <div class="example-item">
            <h4>Button with Loading</h4>
            <tidy-button
              text="Async Action"
              [action]="handleAsyncAction" />
          </div>

          <div class="example-item">
            <h4>Round Button</h4>
            <tidy-round-button
              text="Round"
              [action]="handleButtonClick" />
          </div>

          <div class="example-item">
            <h4>Card Button</h4>
            <tidy-card-button
              text="Card Action"
              [action]="handleButtonClick" />
          </div>

          <div class="example-item">
            <h4>FAB Button</h4>
            <tidy-fab-button
              icon="add"
              [action]="handleButtonClick" />
          </div>
        </div>
      </div>
    </section>

    <!-- Card Components Section -->
    <section class="component-section">
      <h2 class="section-title">Card Components</h2>

      <div class="component-group">
        <h3 class="group-title">Card Variants</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Basic Card</h4>
            <tidy-card>
              <h5>Card Title</h5>
              <p>This is a basic card component with some content.</p>
            </tidy-card>
          </div>

          <div class="example-item">
            <h4>Card with Button</h4>
            <tidy-card>
              <h5>Interactive Card</h5>
              <p>This card contains a button component.</p>
              <tidy-button
                text="Action"
                [action]="handleButtonClick" />
            </tidy-card>
          </div>
        </div>
      </div>
    </section>

    <!-- Table Component Section -->
    <section class="component-section">
      <h2 class="section-title">Table Component</h2>

      <div class="component-group">
        <h3 class="group-title">Data Table</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Data Table</h4>
            <tidy-table
              [data]="tableData"
              [columns]="['id', 'name', 'email', 'status']"
              [sortable]="true"
              [filterable]="true" />
          </div>
        </div>
      </div>
    </section>

    <!-- Stepper Component Section -->
    <section class="component-section">
      <h2 class="section-title">Stepper Component</h2>

      <div class="component-group">
        <h3 class="group-title">Multi-Step Process</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Stepper</h4>
            <tidy-stepper
              [steps]="stepperSteps"
              [currentStep]="currentStep"
              (stepChange)="currentStep = $event" />
            <div class="stepper-controls">
              <tidy-button
                text="Previous"
                [disabled]="currentStep === 0"
                [action]="previousStep" />
              <tidy-button
                text="Next"
                [disabled]="currentStep === stepperSteps.length - 1"
                [action]="nextStep" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Carousel Component Section -->
    <section class="component-section">
      <h2 class="section-title">Carousel Component</h2>

      <div class="component-group">
        <h3 class="group-title">Image Carousel</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Carousel</h4>
            <tidy-carrousel
              [items]="carouselItems"
              [autoPlay]="true"
              [showDots]="true" />
          </div>
        </div>
      </div>
    </section>

    <!-- Drag & Drop Section -->
    <section class="component-section">
      <h2 class="section-title">Drag & Drop Components</h2>

      <div class="component-group">
        <h3 class="group-title">Draggable List</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Drag Drop List</h4>
            <tidy-drag-drop-list
              [items]="dragDropItems"
              (itemMoved)="handleDragDrop($event)" />
          </div>
        </div>
      </div>
    </section>

    <!-- Utility Components Section -->
    <section class="component-section">
      <h2 class="section-title">Utility Components</h2>

      <div class="component-group">
        <h3 class="group-title">Display Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Text Component</h4>
            <tidy-text [largeBody]="'Large Text'" />
            <tidy-text [body]="'Regular Text'" />
            <tidy-text [smallBody]="'Small Text'" />
          </div>

          <div class="example-item">
            <h4>Icon Component</h4>
            <tidy-icon name="home" />
            <tidy-icon name="search" />
            <tidy-icon name="settings" />
          </div>

          <div class="example-item">
            <h4>Image Component</h4>
            <tidy-image
              src="https://via.placeholder.com/150"
              alt="Sample Image"
              width="150"
              height="150" />
          </div>

          <div class="example-item">
            <h4>Divider Component</h4>
            <p>Content above divider</p>
            <tidy-divider />
            <p>Content below divider</p>
          </div>

          <div class="example-item">
            <h4>Loading Components</h4>
            <tidy-loader />
            <tidy-loading-bar />
          </div>

          <div class="example-item">
            <h4>Alert Component</h4>
            <tidy-alert
              type="info"
              message="This is an informational alert" />
          </div>

          <div class="example-item">
            <h4>Error Message Component</h4>
            <tidy-error-message
              message="This is an error message" />
          </div>
        </div>
      </div>
    </section>

    <!-- Modal Section -->
    <section class="component-section">
      <h2 class="section-title">Modal Components</h2>

      <div class="component-group">
        <h3 class="group-title">Modal Dialog</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Modal Component</h4>
            <tidy-button
              text="Open Modal"
              [action]="openModal" />

            <!-- <tidy-modal
              [show]="showModal"
              title="Sample Modal"
              (close)="closeModal()">
              <p>This is the modal content. You can put any content here.</p>
              <tidy-button
                text="Close"
                [action]="closeModal">
              </tidy-button>
            </tidy-modal> -->
          </div>
        </div>
      </div>
    </section>

    <!-- FAB Section -->
    <section class="component-section">
      <h2 class="section-title">FAB Components</h2>

      <div class="component-group">
        <h3 class="group-title">Floating Action Button</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>FAB with List</h4>
            <tidy-button
              text="Toggle FAB"
              [action]="toggleFab" />

            <tidy-fab
              [show]="showFab"
              icon="add"
              [action]="handleButtonClick">
              <tidy-fab-list>
                <tidy-fab-button
                  icon="edit"
                  [action]="handleButtonClick" />
                <tidy-fab-button
                  icon="delete"
                  [action]="handleButtonClick" />
              </tidy-fab-list>
            </tidy-fab>
          </div>
        </div>
      </div>
    </section>

    <!-- Grid and Layout Components -->
    <section class="component-section">
      <h2 class="section-title">Layout Components</h2>

      <div class="component-group">
        <h3 class="group-title">Grid System</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Grid Component</h4>
            <tidy-grid [columns]="3">
              <div class="grid-item">Item 1</div>
              <div class="grid-item">Item 2</div>
              <div class="grid-item">Item 3</div>
            </tidy-grid>
          </div>

          <div class="example-item">
            <h4>Row Components</h4>
            <tidy-row>
              <tidy-two-column-row>
                <div>Left Column</div>
                <div>Right Column</div>
              </tidy-two-column-row>
            </tidy-row>
          </div>

          <div class="example-item">
            <h4>Three Column Row</h4>
            <tidy-three-column-row>
              <div>Column 1</div>
              <div>Column 2</div>
              <div>Column 3</div>
            </tidy-three-column-row>
          </div>
        </div>
      </div>
    </section>

    <!-- Specialized Components -->
    <section class="component-section">
      <h2 class="section-title">Specialized Components</h2>

      <div class="component-group">
        <h3 class="group-title">Calendar and Time Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Best Times Calendar</h4>
            <tidy-best-times-calendar
              [availableSlots]="[]"
              (timeSelected)="handleDateChange($event)" />
          </div>

          <div class="example-item">
            <h4>Bookable Legend</h4>
            <tidy-bookable-legend />
          </div>
        </div>
      </div>

      <div class="component-group">
        <h3 class="group-title">Map Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Map Marker</h4>
            <tidy-marker
              [latitude]="40.7128"
              [longitude]="-74.0060"
              [title]="'New York City'" />
          </div>
        </div>
      </div>

      <div class="component-group">
        <h3 class="group-title">Media Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Video Component</h4>
            <tidy-video
              src="https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4"
              [controls]="true" />
          </div>

          <div class="example-item">
            <h4>Image Viewer</h4>
            <tidy-image-viewer
              [images]="['https://via.placeholder.com/300', 'https://via.placeholder.com/400']"
              [currentIndex]="0" />
          </div>
        </div>
      </div>
    </section>

    <!-- Form Layout Components -->
    <section class="component-section">
      <h2 class="section-title">Form Layout Components</h2>

      <div class="component-group">
        <h3 class="group-title">Form Organization</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Field Pair</h4>
            <tidy-field-pair>
              <tidy-input
                label="First Name"
                [icon]="'assets/svg/person.svg'"
                [form]="inputForm.get('textInput')"
                [submitted]="false" />
              <tidy-input
                label="Last Name"
                [icon]="'assets/svg/person.svg'"
                [form]="inputForm.get('textInput')"
                [submitted]="false" />
            </tidy-field-pair>
          </div>

          <div class="example-item">
            <h4>Filter Component</h4>
            <tidy-filter
              [filters]="selectOptions"
              (filterChange)="handleSelectChange($event)" />
          </div>
        </div>
      </div>
    </section>

    <!-- Search and Navigation Components -->
    <section class="component-section">
      <h2 class="section-title">Search and Navigation</h2>

      <div class="component-group">
        <h3 class="group-title">Search Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Search Input</h4>
            <tidy-search-input
              placeholder="Search..."
              (search)="handleButtonClick" />
          </div>

          <div class="example-item">
            <h4>Message Input</h4>
            <tidy-message-input
              placeholder="Type a message..."
              (send)="handleButtonClick" />
          </div>
        </div>
      </div>
    </section>

    <!-- Tag and Badge Components -->
    <section class="component-section">
      <h2 class="section-title">Tag and Badge Components</h2>

      <div class="component-group">
        <h3 class="group-title">Tags and Labels</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Tag Component</h4>
            <tidy-tag text="Important" />
            <tidy-tag text="New" color="green" />
            <tidy-tag text="Warning" color="orange" />
          </div>
        </div>
      </div>
    </section>

    <!-- Color Picker -->
    <section class="component-section">
      <h2 class="section-title">Color Picker</h2>

      <div class="component-group">
        <h3 class="group-title">Color Selection</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Color Picker</h4>
            <tidy-color-picker
              [form]="inputForm.get('textInput')"
              (colorChange)="handleButtonClick" />
          </div>
        </div>
      </div>
    </section>

    <!-- Wrapper and Container Components -->
    <section class="component-section">
      <h2 class="section-title">Wrapper Components</h2>

      <div class="component-group">
        <h3 class="group-title">Container Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Wrapper Component</h4>
            <tidy-wrapper>
              <p>Content wrapped in tidy-wrapper</p>
            </tidy-wrapper>
          </div>

          <div class="example-item">
            <h4>Scroll Wrapper</h4>
            <tidy-scroll-wrapper>
              <div style="height: 200px; background: #f0f0f0; padding: 20px;">
                <p>Scrollable content goes here...</p>
                <p>This content is scrollable within the wrapper.</p>
                <p>More content to demonstrate scrolling...</p>
              </div>
            </tidy-scroll-wrapper>
          </div>
        </div>
      </div>
    </section>

    <!-- Specialized UI Components -->
    <section class="component-section">
      <h2 class="section-title">Specialized UI Components</h2>

      <div class="component-group">
        <h3 class="group-title">Advanced Components</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Header Toggle</h4>
            <tidy-header-toggle
              title="Toggle Header"
              [expanded]="true">
              <p>Toggle content goes here</p>
            </tidy-header-toggle>
          </div>

          <div class="example-item">
            <h4>Initials Icon</h4>
            <tidy-initials-icon
              name="John Doe"
              size="large" />
          </div>

          <div class="example-item">
            <h4>Photo Note</h4>
            <tidy-photo-note
              [note]="{ text: 'Sample photo note', imageUrl: 'https://via.placeholder.com/100' }" />
          </div>

          <div class="example-item">
            <h4>Round Button Row</h4>
            <tidy-round-button-row
              [buttons]="[
                { text: 'Button 1', action: handleButtonClick },
                { text: 'Button 2', action: handleButtonClick },
                { text: 'Button 3', action: handleButtonClick }
              ]" />
          </div>
        </div>
      </div>
    </section>

    <!-- Bar Component -->
    <section class="component-section">
      <h2 class="section-title">Bar Component</h2>

      <div class="component-group">
        <h3 class="group-title">Progress and Status</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Progress Bar</h4>
            <tidy-bar
              [value]="75"
              [max]="100"
              [showValue]="true" />
          </div>
        </div>
      </div>
    </section>

    <!-- Translations Component -->
    <section class="component-section">
      <h2 class="section-title">Translations Component</h2>

      <div class="component-group">
        <h3 class="group-title">Internationalization</h3>

        <div class="component-examples">
          <div class="example-item">
            <h4>Translation Component</h4>
            <tidy-translations
              [key]="'welcome_message'"
              [params]="{ name: 'User' }" />
          </div>
        </div>
      </div>
    </section>

  </div>
</ion-content>
